<template>
  <div>
    <fusioncharts
      :type="type"
      :width="width"
      :height="height"
      :dataFormat="dataFormat"
      :creditLabel="false"
      :dataSource="dataSource"
    ></fusioncharts>
    <div v-html="message" v-if="message"></div>
  </div>
</template>

<script>
import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import { FCComponent } from "vue-fusioncharts";

export default {
  name: "chart",
  props: ["type", "width", "height", "dataFormat", "dataSource", "message"],
  components: {
    FusionCharts
  }
};
</script>

<style lang="scss">
g[class^="raphael-group-"][class$="-creditgroup"] {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/_commons/chart.vue